import { IListViewTableRow } from '~/src/dash/components/tables/ListViewTable/common';
import { IAdBreakConfig } from '~/src/dash/views/inventory-rules/AllRules/AdBreakDrawer/config';
import { IAdBreak } from '~/src/dash/views/inventory-rules/common';

export const formatDrawerDataIntoLVTRows = (
  data: IAdBreak[],
  cfg: IAdBreakConfig,
): IListViewTableRow[] => {
  return data.map((datum) => {
    const formattedRow = {} as IListViewTableRow;
    Object.values(cfg.table.columns).forEach((col) => {
      const { cellJSX, cellRenderType, cellStyle, formatValue, isNumeric, key, responseKey } = col;
      let value = datum[responseKey as keyof IAdBreak];
      if (isNumeric) {
        value = value !== null ? Number(value) : 'N/A';
      }
      if (formatValue) {
        value = formatValue(value);
      }
      formattedRow[key] = {
        value,
        ...(cellJSX ? { jsx: cellJSX } : {}),
        ...(cellRenderType ? { renderType: cellRenderType } : {}),
        ...(cellStyle ? { cellStyle } : {}),
      };
    });
    return formattedRow;
  });
};
